<template>
  <el-dialog v-model="visible" title="专利详情"  :close-on-click-modal="false" :close-on-press-escape="true" fullscreen :show-close="false">
    
        <el-descriptions class="margin-top" :column="1" size="default" :border="true" label-width="160px">
            <el-descriptions-item label="公开号"><div class="content">{{ featureInfo.PN }}</div></el-descriptions-item>
            <el-descriptions-item label="公开日期"><div class="content">{{ featureInfo.Date }}</div></el-descriptions-item>
            <el-descriptions-item label="摘要"><div class="content">{{ featureInfo.Abstract }}</div></el-descriptions-item>
            <el-descriptions-item label="发明人"><div class="content">{{ featureInfo.Inventors }}</div></el-descriptions-item>
            <el-descriptions-item label="专利权人"><div class="content">{{ featureInfo.Assignee }}</div></el-descriptions-item>
            <el-descriptions-item label="申请人地址"><div class="content">{{ featureInfo.NameAddress }}</div></el-descriptions-item>
            <el-descriptions-item label="申请号"><div class="content">{{ featureInfo.ApplNO }}</div></el-descriptions-item>
            <el-descriptions-item label="申请日期"><div class="content">{{ featureInfo.Filed }}</div></el-descriptions-item>
            <el-descriptions-item label="IPC国际分类号">
              <div class="content">{{ featureInfo.InterClass }}</div>
            </el-descriptions-item>
            <el-descriptions-item label="代理信息">
              <div class="content">{{ featureInfo.AAOFItem }}</div>
            </el-descriptions-item> 
            <el-descriptions-item label="权利要求">
              <div class="content">
                <div v-for="item in featureInfo.ClaimsSrc" :key="item">
                  <span v-for="subItem in item" :key="subItem" class="content">{{ subItem }}</span>
                </div>
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="说明书内容">
                <div v-for="item in featureInfo.DescriptionList" :key="item.title">
                  <div class="title">{{ item.title }}:</div>
                  <div class="content">{{ item.content }}</div>
                </div>
            </el-descriptions-item>
        </el-descriptions>
  </el-dialog>
</template>
<script setup>
import { ref, watch, onMounted, nextTick } from 'vue'
import { Loading, Message, Warning } from '@element-plus/icons-vue'
import { fetchPatentDetail } from '@/api/writing'
import { useRoute } from 'vue-router' 
// 定义组件的props和emits
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  data: {
    type: Object,
    default: () => ({})
  },
  projectId: {
    type: String,
    default: ''
  }
})
const emit = defineEmits(['update:modelValue', 'close', 'save'])

// 响应式数据
const visible = ref(true)
const featureInfo = ref({})
const route = useRoute()
const featureId = ref({})
featureId.value = route.query.id
console.log(featureId.value)
const getfeatureInfo = () => {
  console.log(featureId.value)
  const data = {
    sf: 'ShowPatent',
    sx: 'showpatent_cn',
    sl: 'chs',
    spn: featureId.value
  }
  fetchPatentDetail(data).then(res => {
    console.log(res)
    if(res.statusCode == 200){
        featureInfo.value = JSON.parse(res.body)
        console.log(featureInfo.value)
        featureInfo.value.Inventors = ''
        if (Array.isArray(featureInfo.value.Header.Inventors.InventorsItem)) {
          featureInfo.value.Header.Inventors.InventorsItem.forEach((item, index) => {
          const isLast = index === featureInfo.value.Header.Inventors.InventorsItem.length - 1;
          featureInfo.value.Inventors += item.InventorName + (isLast ? '' : '、')
          })
        }else{
          featureInfo.value.Inventors = featureInfo.value.Header.Inventors.InventorsItem.InventorName
        }
        featureInfo.value.Assignee = featureInfo.value.Header.Assignee.AssigneeItem.AssigneeName
        featureInfo.value.NameAddress = featureInfo.value.Header.NameAddress
        featureInfo.value.ApplNO = featureInfo.value.Header.ApplNO
        featureInfo.value.Filed = featureInfo.value.Header.Filed
        featureInfo.value.InterClass=""
        console.log(featureInfo.value.Classification.InterClass.InterClassEntry)
        if (Array.isArray(featureInfo.value.Classification.InterClass.InterClassEntry)) {
          featureInfo.value.Classification.InterClass.InterClassEntry.forEach(item => {
          featureInfo.value.InterClass += item.InterClassItem + '、'
          })
        }else{
          console.log(featureInfo.value.Classification.InterClass.InterClassItem)
          featureInfo.value.InterClass = featureInfo.value.Classification.InterClass.InterClassEntry.InterClassItem
        }
        console.log(featureInfo.value.Examiner)
        if(featureInfo.value.Examiner){
          featureInfo.value.AAOFItem = featureInfo.value.Examiner.AAOF.AAOFItem
        }else{
          featureInfo.value.AAOFItem = ''
        }
        featureInfo.value.ClaimsSrc =[];
        featureInfo.value.Claims.Claim.forEach((item, index) => {
            featureInfo.value.ClaimsSrc.push(item['']) 
        })
        featureInfo.value.DescriptionList = []
        featureInfo.value.Description.DescriptionPart.forEach(item => {
          var arr = {
            'title': item.name,
            'content': ''
          }
          item.Section.forEach(section => {
            arr.content += section['']
          })
          featureInfo.value.DescriptionList.push(arr)
        })
        console.log(featureInfo.value.DescriptionList)
    }else{
        Message.error('获取专利详情失败')
    }
  }).catch(() => {
  })
}
// 关闭弹框
const handleClose = () => {
  visible.value = false
  emit('close')
}
onMounted(() => {
  console.log(1)
  nextTick(() => {
      getfeatureInfo()
  })

})



</script>
<style scoped>
.mermaid-dialog {
  --el-dialog-margin-top: 0vh;
}
.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.dialog-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}
.dialog-actions {
  display: flex;
  gap: 8px;
  margin-right: 40px;
}
.mermaid-content {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: auto;
}
.chart-section {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background-color: #fafafa;
  overflow: auto;
  min-height: 400px;
}
.loading-container,
.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  color: #909399;
}
.error-container {
  color: #F56C6C;
}
.chart-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  overflow: auto;
}
/* 确保SVG图表正确显示 */
.chart-container :deep(svg) {
  max-width: 100%;
  max-height: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
}
/* Mermaid图表特定样式 */
.chart-container :deep(.mermaid-chart) {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.chart-container :deep(.mermaid-chart svg) {
  max-width: 100%;
  max-height: 100%;
}
.title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}
.content {
  font-size: 14px;
  color: #606266;
}
</style>
